<template>
  <BaseButton
    text
    color="white"
    retain-focus-on-click
    :ripple="false"
    :class="isIconDisabled ? 'disabled disabled-icon' : ''"
    :disabled="!isCategoriesExist"
    @click="createAnnotationHandler()"
  >
    <BaseSpriteIcon icon-name="ico-file-edit-line"></BaseSpriteIcon>
    <span class="context-menu-text-item">{{ $t('Context.short.note') }}</span>
  </BaseButton>
</template>

<script>
import BaseSpriteIcon from '@/components/base/BaseSpriteIcon/BaseSpriteIcon.vue';
import BaseButton from '@/components/base/BaseButton/BaseButton';

import GoogleAnalyticsUtils from '@/services/utils/GoogleAnalyticsUtils';
import PromiseUtil from '@/services/utils/PromiseUtil';
import FeatureDetectorService from '@/services/FeatureDetector/FeatureDetectorService';

import PopupNamesEnum from '@/enums/PopupNamesEnum';

import ContextMenuParamsFactory from '@/classes/factories/Materials/ContextMenuParamsFactory';

export default {
  name: 'CreateAnnotationControl',
  components: {
    BaseSpriteIcon,
    BaseButton
  },
  computed: {
    bookId() {
      const openParams = this.$store.getters[
        'OpenParameterStore/getPublicationOpenParameters'
      ];
      return openParams?.publicationId;
    },
    selectedLocator() {
      return this.$store.getters['MaterialsStore/getSelectedLocator'];
    },
    getAnnotationFullSelectedByLocator() {
      return this.$store.getters[
        'AnnotationsStore/getAnnotationFullSelectedByLocator'
      ](this.selectedLocator, this.bookId);
    },
    isGuest() {
      return this.$store.getters['UserStore/isGuestUser'];
    },
    isDisabledIconInAttr() {
      return this.$attrs['icon-disabled'];
    },
    categories() {
      return this.$store.getters['CategoriesStore/getShownCategories'] || [];
    },
    isCategoriesExist() {
      return this.categories.length;
    },
    isIconDisabled() {
      return (
        this.isDisabledIconInAttr || !this.isCategoriesExist || this.isGuest
      );
    }
  },
  methods: {
    $_openEditAnnPopup() {
      const menuPosition = ContextMenuParamsFactory.createMenuPosition();
      this.$store.dispatch('ManagePopupStore/openPopup', {
        name: PopupNamesEnum.CREATE_ANNOTATION_POPUP,
        popupContext: {
          annotation: null,
          menuPosition
        }
      });
    },
    $_processAddNoteEvent() {
      this.$store.dispatch('PaymentsStore/wrappWithGuestLogic', {
        handler: this.$_openEditAnnPopup
      });
    },
    async createAnnotationHandler() {
      await PromiseUtil.wait(200);
      if (this.isDisabledIconInAttr && !this.isGuest) {
        this.$store.dispatch('ManagePopupStore/openToaster', {
          text: this.$t('AnnotationControl.toaster.disabled.message'),
          toasterClose: false
        });
        return;
      }
      this.$store.dispatch('PlaybackStore/pause');
      GoogleAnalyticsUtils.trackEvent('book', 'contextMenu', 'createNote');
      const { indexDB } = await FeatureDetectorService.getDetections();
      if (indexDB) {
        this.$_processAddNoteEvent();
      } else {
        this.$store.dispatch('ManagePopupStore/openUsageSuggestionPopup');
      }
    }
  }
};
</script>
